import { Model, User } from ".";

export default class Department extends Model {
	get singularNoun() {
		return "department";
	}

	get mutations() {
		return {
			users: User
		};
	}
}
